import { poisBountyAssets } from "assets/cdn";

export interface LearnMoreItem {
	image: string;
	title: string;
	description: string;
}

export const itemsV2: LearnMoreItem[] = [
	{
		image: poisBountyAssets.v2.ftue.loyalty.first,
		title: "Make purchases in the Web Shop",
		description:
			"Purchase items in the shop during the event to collect Loyalty Points."
	},
	{
		image: poisBountyAssets.v2.ftue.loyalty.second,
		title: "Collect Loyalty Points",
		description:
			"Loyalty Points from your purchases will be reflected in the Poi's Bounty Meter."
	},
	{
		image: poisBountyAssets.v2.ftue.loyalty.third,
		title: "Claim Rewards & Keep Going",
		description:
			"Once your meter is filled, claim your rewards & keep advancing until the event concludes."
	}
];

export const itemsV3: LearnMoreItem[] = [
	{
		image: poisBountyAssets.v2.ftue.loyalty.first,
		title: "Make Purchases via Web payments",
		description:
			"Purchase items in the Web Shop or via in app using Web Payments to collect Loyalty Points."
	},
	{
		image: poisBountyAssets.v2.ftue.loyalty.second,
		title: "Collect Loyalty Points together",
		description:
			"Loyalty Points from your and your Club mate’s purchases will be reflected  in the event’s meter! Watch it rise all together!"
	},
	{
		image: poisBountyAssets.v2.ftue.loyalty.third,
		title: " Collect all Rewards from Poi & Start Again!",
		description:
			"After your Club’s meter is full, collect your rewards! Your Club may play Poi’s Bounty until the event ends."
	}
];
